import { render, staticRenderFns } from "./RoleDescriptionPopup.vue?vue&type=template&id=9c3cebd8&scoped=true"
import script from "./RoleDescriptionPopup.vue?vue&type=script&lang=js"
export * from "./RoleDescriptionPopup.vue?vue&type=script&lang=js"
import style0 from "./RoleDescriptionPopup.vue?vue&type=style&index=0&id=9c3cebd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3cebd8",
  null
  
)

export default component.exports